import React from 'react'
import './CardTeam.css'
import IconOne from './../../assets/Home/CardIcon/1000_F_547864264_MjWWHptvkcSuTkajA6XM4m6ro5cvZQBe.png'
import IconTow from './../../assets/Home/CardIcon/bank.png'
import { Box, Typography } from '@mui/material'

function CardTeam({ myTitle, descHome, descComp, imgCard, width = '100%', nameWorking, name
}) {
    return (
        <Typography className="card m-2" style={{ maxWidth: "540px;" }}>
            <Typography className="row g-0 align-items-center justify-content-between">
                <Typography className="col-md-8" sx={{ fontWeight: 'bold' }} >
                    {myTitle}
                    <Typography className="card-body" sx={{ fontWeight: 'bold' }} >
                        <Typography sx={{ p: 2, fontWeight: 'bold' }} className="card-text">{descHome} </Typography>
                        {descComp}
                        <Box>
                            <Typography variant="body1" textAlign={"left"} sx={{ fontWeight: 'bold' }} >
                                {nameWorking}
                                <br />
                                {name}
                            </Typography>
                        </Box>
                        <Typography className="d-flex justify-content-evenly m-2">
                            <Typography className="boxIcon">
                                <img src={IconTow} alt="" />
                            </Typography>
                            <Typography className="boxIcon">
                                <img src={IconTow} alt="" />
                            </Typography>
                            <Typography className="boxIcon">
                                <img src={IconOne} alt="" />
                            </Typography>
                        </Typography>
                        
                    </Typography>
                </Typography>
                <Box className="col-md-4" sx={{ textAlign: 'center' }}>
                    <img src={imgCard} className="img-fluid rounded-start" alt="..." style={{ width: width }} />
                </Box>
            </Typography>
        </Typography>
    )
}

export default CardTeam